import { render, staticRenderFns } from "./InAssigningQuoteNumberStageTable.vue?vue&type=template&id=6988a46f"
import script from "./InAssigningQuoteNumberStageTable.vue?vue&type=script&lang=js"
export * from "./InAssigningQuoteNumberStageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports